module.exports = __webpack_public_path__ + "static/fonts/Inter-Tight.6c7bcaa8.ttf";